import React, { forwardRef, useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
//import IsLoadingImg from "../../assests/images/isloading.png";
import ErrorIcon from "../../assets/images/erroricon.png";
import liveIcon from '../../assets/images/live.png'
import Typography from "@mui/material/Typography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { makeStyles, withStyles } from "@mui/styles";
import TranslateIcon from "@mui/icons-material/Translate";
import Button from "@mui/material/Button";

import IconButton from "@mui/material/IconButton";
import SignalCellularAltIcon from "@mui/icons-material/SignalCellularAlt";
import Replay10Icon from "@mui/icons-material/Replay10";
import Forward10Icon from "@mui/icons-material/Forward10";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import Slider from "@mui/material/Slider";
import Tooltip from "@mui/material/Tooltip";
import Grid from "@mui/material/Grid";
import VolumeUp from "@mui/icons-material/VolumeUp";
import VolumeDown from "@mui/icons-material/VolumeDown";
import VolumeMute from "@mui/icons-material/VolumeOff";
import ClosedCaptionIcon from "@mui/icons-material/ClosedCaption";
import FullScreen from "@mui/icons-material/Fullscreen";
import FullscreenExit from "@mui/icons-material/FullscreenExit";
import PictureInPictureIcon from "@mui/icons-material/PictureInPicture";
import PictureInPictureAltIcon from "@mui/icons-material/PictureInPictureAlt";
import SettingsIcon from "@mui/icons-material/Settings";
import CloseIcon from "@mui/icons-material/Close";
import Ticker, { NewsTicker } from "nice-react-ticker";
import globalIcon from "../../assets/images/languageIcon.png";
import SkipNextIcon from "@mui/icons-material/SkipNext";
import LanguageIcon from '@mui/icons-material/Language';
import { useHistory } from "react-router-dom";
import CircularProgress from '@mui/material/CircularProgress';
import Switch from '@mui/material/Switch';

const useStyles = makeStyles((theme) => ({
  controlsWrapper: {
    visibility: "hidden",
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    height: "100%",
    background: "rgba(0,0,0,0)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },

  errorDisplay: {
    visibility: "visible",
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    height: "100%",
    background: "rgba(0,0,0,0)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },

  controlsWrapperwithshadow: {
    background: "rgba(0,0,0,0.4)",
  },

  button: {
    // margin: theme.spacing(1),
    margin: "5px",
  },
  controlIcons: {
    color: "#777",

    fontSize: 50,
    transform: "scale(0.9)",
    "&:hover": {
      color: "#fff",
      transform: "scale(1)",
    },
  },

  bottomIcons: {
    // padding:'4px',
    color: "#999",
    "&:hover": {
      color: "#fff",
    },
  },

  volumeSlider: {
    width: 100,
  },
}));
const VideoSlider = withStyles({
  root: {
    height: 8,
  },
  thumb: {
    height: 15,
    width: 15,
    backgroundColor: "#fff",
    border: "2px solid currentColor",
    marginTop: -5,
    marginLeft: -12,
    "&:focus, &:hover, &$active": {
      boxShadow: "inherit",
    },
  },
  active: {},
  valueLabel: {
    left: "calc(-50% + 4px)",
  },
  track: {
    height: 5,
    borderRadius: 4,
  },
  rail: {
    height: 5,
    borderRadius: 4,
  },
})(Slider);

// function ValueLabelComponent(props) {
//     const { children, open, value } = props;

//     return (
//         <Tooltip open={open} enterTouchDelay={0} placement="top" title={value}>
//             {children}
//         </Tooltip>
//     );
// }

const Controls = forwardRef(
  (
    {
      handelChecked,
      handelToggleVisible,
      checked,
      isAdsShowing,
      isMacOS,
      onSeek,
      nextVod,
      isAudio,

      tickerLanguageControls,
      onPlayerRefrence,
      onSeekMouseDown,
      onSeekMouseUp,
      onDuration,
      tikcerdata,
      onRewind,
      onPlayPause,
      onFastForward,
      playing,
      showSpinner,
      played,
      elapsedTime,
      totalDuration,
      onMute,
      muted,
      showvolumeControl,
      onVolumeSeekDown,
      setConfig,
      subtitleTracksSelected,
      currentaudioTrack,
      levellsmain,
      livecount,
      fullScreen,
      onFramerate,
      onsubtitleTracks,
      onToggleFullScreen,
      onsubtitleTracksdisplay,
      handleClose,
      nextEpisodePlay,
      handelnextduration,
      subtitleDisplays,
      volume,
      onVolumeChange,
      languagedata,
      tittle,
      onPip,
      pip,
      errorAlert,
      errorMessage,
      isPlayer,
      catType,
      cuepPonits,
      hideSeekbar
    },
    ref
  ) => {
    const history = useHistory();
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [bitRateEl, setbitRateEl] = React.useState(null);
    const [subtitleTracksEl, setsubtitleTracksEl] = React.useState(null);
    const [settingControls_wrapper, set_settingControls_wrapper] =
      React.useState(false);
    const [activeSettingTab, setactiveSettingTab] = React.useState("tab1");
    const [onframe, setonframe] = React.useState("0");
    const [isShowVolumeSlider, setIsShowVolumeSlider] = useState(false);
    const [settingControls, setsettingControls] = useState(false);
    const [settingLanguageControls, setsettingLanguageControls] =
      useState(false);
    const [subTitleDrop, setsubTitleDrop] = useState(false);
    const [tickerdataMain, settickerdataMain] = useState([]);
    const [description, setdescription] = useState("");
    const [languagedefault, setlanguagedefault] = useState("");
    const windowSize = useRef([window.innerWidth, window.innerHeight]);
    const [windowWidth, setwindowWidth] = useState(windowSize.current[0]);
    const videoPlayBtn = useRef();
    // const [checked, setChecked] = useState(false);
    useEffect(() => {
      // alert(setConfig)
      if (setConfig !== true) {
        if (
          tikcerdata !== undefined &&
          tikcerdata !== null &&
          tikcerdata !== ""
        ) {
          settickerdataMain(tikcerdata);
          let currentvalue =
            tikcerdata !== undefined ? tikcerdata[0].language : [];
          setlanguagedefault(currentvalue);
          for (let i = 0; i < tikcerdata.length; i++) {
            //
            let languagefirst = tikcerdata[i].language;
            if (currentvalue === languagefirst) {
              let description = tikcerdata[i].description;
              setdescription(description);
            }
          }
        }
      }
    }, [tickerdataMain]);

    const handleAudiochange = (e) => {
      let target = e.currentTarget;
      for (
        let i = 0;
        i < target.parentElement.parentElement.children.length;
        i++
      ) {
        target.parentElement.parentElement.children[i].classList.remove(
          "active"
        );
      }
      target.parentElement.classList.add("active");

      let refplayer = onPlayerRefrence.current.getInternalPlayer("hls"); // player refrence come via propsType
      refplayer.audioTrack = target.getAttribute("data-value");

      setAnchorEl(null);
      set_settingControls_wrapper(false);
      setsubTitleDrop(false);
      videoPlayBtn.current.classList.remove("d-none");
      //document.querySelector("#videoPlayBtn").classList.remove("d-none");
    };

    const handlesubtitlechange = (e) => {
      let target = e.currentTarget;
      for (
        let i = 0;
        i < target.parentElement.parentElement.children.length;
        i++
      ) {
        target.parentElement.parentElement.children[i].classList.remove(
          "active"
        );
      }
      target.parentElement.classList.add("active");
      let refplayer = onPlayerRefrence.current.getInternalPlayer("hls");
      refplayer.subtitleTrack = target.getAttribute("data-value");
      refplayer.subtitleDisplay = true;
      setsubtitleTracksEl(null);
      set_settingControls_wrapper(false);
      setsubTitleDrop(false);
      videoPlayBtn.current.classList.remove("d-none");
      //document.querySelector("#videoPlayBtn").classList.remove("d-none");
    };

    const tickerLanguge = (e) => {
      setsettingLanguageControls(!settingLanguageControls);
      set_settingControls_wrapper(false);
      setsubTitleDrop(false);
      setsettingControls(false);
      // e.currentTarget.nextSibling.classList.add('d-block');
    };

    const handleVideochangeauto = (e) => {
      let target = e.currentTarget;

      for (
        let i = 0;
        i < target.parentElement.parentElement.children.length;
        i++
      ) {
        target.parentElement.parentElement.children[i].classList.remove(
          "active"
        );
      }
      target.parentElement.classList.add("active");
      let refplayer = onPlayerRefrence.current.getInternalPlayer("hls");
      refplayer.currentLevel = -1;
      setonframe(-1);
      setbitRateEl(null);
      set_settingControls_wrapper(false);
      setsettingControls(false);
    };
    // const nextEpisodePlay = () => {
    //   // 

    //   if (nextVod !== null && nextVod !== undefined) {

    //     let tittle = encodeURIComponent(nextVod?.title.replace(/[|:;.,\s]/g, "").toLowerCase()); // Sanitizing category name for URL
    //     let entryid = nextVod.entryid;
    //     let catid = nextVod.catid;
    //     let url = `/watch/${catType}/${tittle}/${entryid}`;
    //     // history.push(url);
    //     setState({
    //       ...state,
    //       playedsec: 0,
    //       playedbackup: 0
    //     });
    //     history.push({ // Navigating to URL
    //       pathname: url,
    //       state: {
    //         cattype: catType ?? '',
    //         entryid: entryid ?? '',
    //         catid: catid ?? ''
    //       }
    //     });
    //   }
    // };
    const handleVideochange = (e) => {
      let target = e.currentTarget;
      for (
        let i = 0;
        i < target.parentElement.parentElement.children.length;
        i++
      ) {
        target.parentElement.parentElement.children[i].classList.remove(
          "active"
        );
      }
      target.parentElement.classList.add("active");
      let refplayer = onPlayerRefrence.current.getInternalPlayer("hls"); // player refrence come via propsType
      refplayer.currentLevel = parseInt(target.getAttribute("data-value"));
      //refplayer.currentLevel = 3;
      let data = parseInt(target.getAttribute("data-value"));
      setonframe(data);
      setbitRateEl(null);
      set_settingControls_wrapper(false);
      setsettingControls(false);
    };

    const setting_Control_tab = (e) => {
      setactiveSettingTab(e.currentTarget.value);
    };

    const handleSettingTab = () => {
      setsettingControls(true);
    };

    const handleSettingTabClose = () => {
      set_settingControls_wrapper(false);
      setsettingControls(false);
      setsubTitleDrop(false);
      videoPlayBtn.current.classList.remove("d-none");
      //document.querySelector("#videoPlayBtn").classList.remove("d-none");
    };

    const openSettingDropdown = (e) => {
      set_settingControls_wrapper(true);
      setsettingControls(!settingControls);
      e.currentTarget.nextSibling.classList.add("d-block");
      setsubTitleDrop(false);
    };

    const openSubtitleDrop = (e) => {
      set_settingControls_wrapper(true);
      setsettingLanguageControls(false);
      setsubTitleDrop(!subTitleDrop);

      e.currentTarget.nextSibling.classList.add("d-block");
      setsettingControls(false);
      videoPlayBtn.current.classList.remove("d-none");
      //document.querySelector("#videoPlayBtn").classList.add("d-none");
    };

    const closePlayerDrop = () => {
      setsettingControls(false);
      setsubTitleDrop(false);
    };
    const handleTickerLanguagechange = (e, lang) => {
      //
      let target = e.currentTarget;
      let currentvalue = target.getAttribute("data-value");
      setlanguagedefault(currentvalue);
      for (let i = 0; i < tikcerdata.length; i++) {
        //
        let languagefirst = tikcerdata[i].language;
        if (currentvalue === languagefirst) {
          let description = tikcerdata[i].description;
          setdescription(description);
          setsettingLanguageControls(!settingLanguageControls);
        }
      }
    };

    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;

    document.body.onkeypress = function (e) {
      var keycode = e.keyCode ? e.keyCode : e.which;
      if (keycode == "32") {
        onPlayPause();
        e.preventDefault();
        playing
          ? document
            .querySelector("#playercontainer_wrapper")
            .classList.add("show")
          : document
            .querySelector("#playercontainer_wrapper")
            .classList.remove("show");
      }
    };
    const playnext = () => {
      handelnextduration()
      nextEpisodePlay()
    };

    return !showSpinner ? (
      <>

        {setConfig ? (
          ""
        ) : (
          <>

            {tickerdataMain !== undefined &&
              tickerdataMain !== null &&
              tickerdataMain.length > 0 ? (
              <div className="newsticker">
                <Ticker>
                  <NewsTicker title={description} />
                </Ticker>
                <div className="lngbth playerDropdownWrapper">
                  <button
                    type="button"
                    className="glbbtn"
                    onClick={tickerLanguge}
                  >
                    <img src={globalIcon} alt={globalIcon} />
                  </button>
                  <div
                    className={`playerDropdown ${settingLanguageControls === true ? "show" : "hide"
                      }`}
                  >
                    <h4 className="text-white pt-3 pb-2">Languages</h4>
                    <ul className="d-block pl-0 w-100">
                      {tickerdataMain !== undefined &&
                        tickerdataMain !== null &&
                        tickerdataMain.map((result, key) => {
                          return (
                            <li
                              className={`w-100 ${result.language === languagedefault
                                ? "active"
                                : ""
                                }`}
                            >
                              <Button
                                className="MuiButtonBase-root MuiButton-root MuiButton-text text-white w-100"
                                onClick={handleTickerLanguagechange}
                                data-value={
                                  result.language ? result.language : ""
                                }
                              >
                                {result.language ? result.language : ""}
                              </Button>
                            </li>
                          );
                        })}

                      {/* <li className="w-100 ">
                    <Button className="MuiButtonBase-root MuiButton-root MuiButton-text text-white w-100  undefined active" data-value={-2}>
                      English
                    </Button>
                  </li>
                  <li className="w-100 ">
                    <Button className="MuiButtonBase-root MuiButton-root MuiButton-text text-white w-100  undefined" data-value={-3}>
                      Tamil
                    </Button>
                  </li>
                  <li className="w-100 ">
                    <Button className="MuiButtonBase-root MuiButton-root MuiButton-text text-white w-100  undefined" data-value={-4}>
                      Telugu
                    </Button>
                  </li>
                  <li className="w-100 ">
                    <Button className="MuiButtonBase-root MuiButton-root MuiButton-text text-white w-100  undefined" data-value={-5}>
                      Kannada
                    </Button>
                  </li> */}
                    </ul>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </>
        )}

        {/*  {
          livecount !== undefined && livecount !== null && livecount !== '' ? <>
            {
              isPlayer ? '' : <div className='livbtn-wppr'>
                <div className='livrtx'>
                  <p>Live</p>
                </div>
               
              </div>
            }
          </> : ''
        }*/}
        {isAdsShowing ? (
          <div
            ref={ref}
            id="playercontainer_wrapper"
            className={`playercontainer_wrapper playerNewControls ${classes.controlsWrapper
              } ${fullScreen ? "fullscreen" : ""}`}
          >
            <Grid
              container
              className={`playercontainer position-absolute h-100 addControls`}
            >
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                className="player_title"
              >
                <div className="d-flex align-items-center joy addVolumeBtn">
                  <IconButton
                    onClick={onMute}
                    className={`${classes.bottomIcons} ${classes.volumeButton}`}
                  >
                    {muted ? (
                      <VolumeMute fontSize="small" />
                    ) : volume > 0.5 ? (
                      <VolumeUp fontSize="small" />
                    ) : (
                      <VolumeDown fontSize="small" />
                    )}
                  </IconButton>
                  <Slider
                    min={0}
                    max={100}
                    value={muted ? 0 : volume * 100}
                    onChange={onVolumeChange}
                    aria-labelledby="input-slider"
                    className={`range_vol ${classes.volumeSlider}`}
                    onMouseDown={onSeekMouseDown}
                    onChangeCommitted={onVolumeSeekDown}
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        ) : (
          <div
            ref={ref}
            id="playercontainer_wrapper"
            className={`playercontainer_wrapper playerNewControls ${classes.controlsWrapper
              } ${fullScreen ? "fullscreen" : ""}`}
          >
            {settingControls_wrapper === true ? (
              <div className="overlay_" onClick={handleSettingTabClose}></div>
            ) : (
              ""
            )}

            {isMacOS === false && <Tooltip title="Pip" placement="left">
              <IconButton
                onClick={onPip}
                className={`${classes.bottomIcons} popIcon`}
              >
                {pip ? (
                  <PictureInPictureAltIcon fontSize="small" />
                ) : (
                  <PictureInPictureIcon fontSize="small" />
                )}
              </IconButton>
            </Tooltip>}

            <h4 className="title text-white text-capitalize w-100 d-flex position-relative">
              {" "}
              {tittle && tittle.toLowerCase()}
              {handleClose !== null &&
                handleClose !== undefined &&
                handleClose !== "" ? (
                <Button className="close_" onClick={handleClose}>
                  <CloseIcon />
                </Button>
              ) : (
                ""
              )}
            </h4>

            <div className="videoControls d-flex align-items-center flex-column">
              <div className="row d-flex align-items-center videoControls_row">
                <div className="col-md-4 d-flex align-items-center p-0 col1">
                  <Grid
                    direction="row"
                    alignItems="center"
                    justify="center"
                    align="center"
                    className="playercontrolls__next_prev_wrapper"
                  >
                    {
                      //  !setConfig ? (<Grid
                      //   item
                      //   xs={12}
                      //   sm={12}
                      //   md={12}
                      //   lg={12}
                      //   xl={12}
                      //   className="playercontrolls"
                      // >

                      // </Grid>) :

                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className="playercontrolls"
                      >
                        <Tooltip title="Rewind" placement="bottom">
                          <IconButton
                            onClick={onRewind}
                            className={classes.controlIcons}
                            aria-label="rewind"
                          >
                            <Replay10Icon
                              className={classes.controlIcons}
                              fontSize="inherit"
                            />
                          </IconButton>
                        </Tooltip>
                        <Tooltip
                          title={playing ? "Pause" : "Play"}
                          placement="bottom"
                        >
                          <IconButton
                            onClick={onPlayPause}
                            className={classes.controlIcons}
                            aria-label="play"
                          >
                            {playing ? (
                              <PauseIcon fontSize="inherit" />
                            ) : (
                              <PlayArrowIcon fontSize="inherit" />
                            )}
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Forward" placement="bottom">
                          <IconButton
                            onClick={onFastForward}
                            className={classes.controlIcons}
                            aria-label="forward"
                          >
                            <Forward10Icon fontSize="inherit" />
                          </IconButton>
                        </Tooltip>
                      </Grid>
                    }
                  </Grid>

                  {
                    isPlayer === 'live' ? "" : <span className="mx-3 text-white font-13 d-flex aign-items-center videoDuration">
                      {elapsedTime}/{totalDuration}
                    </span>
                  }
                  {
                    isPlayer === 'live' ? <img src={liveIcon} alt="live" className="liveicon" /> : ''
                  }

                </div>

                <div className="col-md-8 p-0 col2">
                  <div className="ml-auto w-100 d-flex align-items-center justify-content-end playerLastButtons">
                    {/* <Tooltip title="Next" placement="bottom">
                    <IconButton
                      className={`${classes.bottomIcons}`}

                    >
                      <SkipNextIcon className="font-24" />
                    </IconButton>
                  </Tooltip> */}
                    {setConfig && nextVod ? (
                      <Button
                        onClick={playnext}
                        className="mx-3 next-episode d-flex align-items-center justify-content-center"
                      >
                        <SkipNextIcon /> {windowWidth > 992 && 'Next'}
                      </Button>
                    ) : (
                      ""
                    )}

                    {(languagedata.length > 1 && onsubtitleTracks.length > 0) ||
                      languagedata.length > 1 ||
                      onsubtitleTracks.length > 0 ? (
                      <div className="playerDropdownWrapper position-relative">
                        <Button
                          className="mx-3 next-episode d-flex align-items-center justify-content-center"
                          onClick={openSubtitleDrop}
                        >
                          {" "}
                          {windowWidth > 992 ? 'Language & Subtitle' : <LanguageIcon />}
                        </Button>

                        <div
                          className={`playerDropdown subtitleDropdown ${subTitleDrop === true ? "show" : "hide"
                            }`}
                        >
                          <div className="d-flex">
                            {languagedata !== undefined &&
                              languagedata.length > 1 && (
                                <div className="col p-0">
                                  <h4 className="text-white pt-3 pl-3 pb-2">
                                    Language
                                  </h4>
                                  <ul className="d-block pl-0 w-100 my-0 language">
                                    {languagedata !== undefined &&
                                      languagedata.length > 0 &&
                                      languagedata.map((result, i) => {
                                        // {alert("currentaudiotrack"+currentaudioTrack)}
                                        return (
                                          <li
                                            className={`w-100 ${currentaudioTrack === result.id
                                              ? "active"
                                              : ""
                                              }`}
                                          >
                                            <Button
                                              className={`text-white w-100 text-center links ${classes.langp} `}
                                              key={i}
                                              name={result.lang}
                                              onClick={handleAudiochange}
                                              data-value={result.id}
                                            >
                                              {result.name.toLowerCase()}
                                            </Button>
                                          </li>
                                        );
                                      })}
                                  </ul>
                                </div>
                              )}
                            {/* {
                        ('onsubtitleTracks', onsubtitleTracks)
                       } */}
                            {onsubtitleTracks !== undefined &&
                              onsubtitleTracks.length > 0 && (
                                <div className="col p-0">
                                  <h4 className="text-white pt-3 pl-3 pb-2">
                                    Subtitles
                                  </h4>
                                  {onsubtitleTracks !== undefined &&
                                    onsubtitleTracks.length > 0 && (
                                      <ul className="d-block pl-0 w-100">
                                        <li
                                          className="w-100"
                                          onClick={closePlayerDrop}
                                        >
                                          <Button
                                            className={`text-white w-100 text-center ${classes.langp}`}
                                            onClick={onsubtitleTracksdisplay}
                                          >
                                            {/* {subtitleDisplays ? "Off" : "On"} */}
                                            Off
                                          </Button>
                                        </li>
                                        {onsubtitleTracks !== undefined &&
                                          onsubtitleTracks.length > 0 &&
                                          onsubtitleTracks.map((result, i) => {
                                            //alert('jkk')
                                            return (
                                              <li
                                                className={`w-100 ${subtitleTracksSelected ===
                                                  result.id
                                                  ? "active"
                                                  : ""
                                                  }`}
                                              >
                                                <Button
                                                  className={`text-white w-100 text-center ${classes.langp}`}
                                                  onClick={handlesubtitlechange}
                                                  data-value={result.id}
                                                >
                                                  {result.name.toLowerCase()}
                                                </Button>
                                              </li>
                                            );
                                          })}
                                      </ul>
                                    )}
                                </div>
                              )}
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}



                    <div className="playerDropdownWrapper position-relative">

                      <Tooltip title="Setting" placement="bottom">
                        <IconButton
                          className={classes.bottomIcons}
                          onClick={openSettingDropdown}
                          style={{ opacity: checked === false ? '1' : '0', visibility: checked === false ? 'inherit' : 'hidden' }}
                        >
                          <SettingsIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>

                      {isAudio && <Tooltip title={checked ? 'Video Only' : 'Audio Only'} arrow>
                        <Switch className="toogler"
                          checked={checked}
                          onChange={() => handelChecked(!checked)}
                          inputProps={{ 'aria-label': 'controlled' }}
                          onMouseOut={handelToggleVisible}

                        />
                      </Tooltip>}

                      <div
                        className={`playerDropdown ${settingControls === true ? "show" : "hide"
                          }`}
                      >
                        <h4 className="text-white pt-3 pl-3 pb-2">
                          Video Quality
                        </h4>
                        <ul className="d-block pl-0 w-100">
                          <li
                            className={`w-100 ${levellsmain === -1 ? "active" : ""
                              }`}
                          >
                            <Button
                              className={`text-white w-100 text-center ${classes.langp}`}
                              onClick={handleVideochangeauto}
                              data-value={-1}
                            >
                              {"Auto"}
                            </Button>
                          </li>
                          {onFramerate !== undefined &&
                            onFramerate.length > 0 &&
                            onFramerate.map((items, i) => {
                              //console.log("items",levellsmain)
                              return (
                                <li
                                  className={`w-100 ${levellsmain === items.id ? "active" : ""
                                    }`}
                                >
                                  <Button
                                    className={`text-white w-100 text-center ${classes.langp}`}
                                    key={i}
                                    onClick={handleVideochange}
                                    data-value={i}
                                  >
                                    {" "}
                                    {items.height
                                      ? items.height
                                      : items.attrs.BANDWIDTH / 1000}
                                    {items.height ? `p` : ` kbps`}
                                  </Button>
                                </li>
                              );
                            })}
                        </ul>
                      </div>
                    </div>

                    <div
                      className="position-relative volumeSliderWrap"
                      onClick={closePlayerDrop}
                    >
                      <Tooltip
                        title={muted ? "Unmute" : "Mute"}
                        placement="bottom"
                      >
                        <IconButton
                          onClick={onMute}
                          className={`${classes.bottomIcons} ${classes.volumeButton}`}
                        >
                          {muted ? (
                            <VolumeMute fontSize="small" />
                          ) : volume > 0.5 ? (
                            <VolumeUp fontSize="small" />
                          ) : (
                            <VolumeDown fontSize="small" />
                          )}
                        </IconButton>
                      </Tooltip>

                      <Slider
                        orientation="vertical"
                        min={0}
                        max={100}
                        value={muted ? 0 : volume * 100}
                        onChange={onVolumeChange}
                        aria-labelledby="input-slider"
                        // aria-labelledby="vertical-slider"
                        className={`range_vol ${classes.volumeSlider}`}
                        onMouseDown={onSeekMouseDown}
                        onChangeCommitted={onVolumeSeekDown}
                      />
                    </div>

                    <Tooltip
                      title={
                        fullScreen ? "Exit Fullscreen (f)" : "Fullscreen (f)"
                      }
                      placement="bottom"
                    >
                      <IconButton
                        onClick={onToggleFullScreen}
                        className={classes.bottomIcons}
                      >
                        {fullScreen ? (
                          <FullscreenExit fontSize="small" />
                        ) : (
                          <FullScreen fontSize="small" />
                        )}
                      </IconButton>
                    </Tooltip>

                  </div>
                </div>
              </div>

              {isPlayer === 'live' ? '' : <VideoSlider
                min={0}
                max={100}
                videoslidercomponents={(props) => (
                  <videoslidercomponents {...props} value={elapsedTime} />
                )}
                aria-label="custom thumb label"
                value={played * 100}
                onChange={onSeek}
                onMouseDown={onSeekMouseDown}
                onChangeCommitted={onSeekMouseUp}
                onDuration={onDuration}
                className="control_seekbar"
              />}



            </div>

            <div className="ControlsOverlay playPause" onClick={onPlayPause}>
              <IconButton
                onClick={onPlayPause}
                className={`${classes.controlIcons}`}
                aria-label="play"
                id="videoPlayBtn"
                ref={videoPlayBtn}
              >
                {playing ? (
                  <PauseIcon fontSize="inherit" className="text-white" />
                ) : (
                  <PlayArrowIcon fontSize="inherit" className="text-white" />
                )}
              </IconButton>
            </div>
          </div>
        )}
      </>
    ) : errorAlert === false ? (
      <div
        ref={ref}
        className={`playercontainer_wrapper ${classes.controlsWrapper}`}
        style={{ backgroundColor: "#333" }}
      >

        <div className="loader">
          {/* <img src={IsLoadingImg} className="loadimg" alt ="loader"/> */}
          <CircularProgress color="inherit" />
        </div>
      </div>
    ) : (
      <div
        ref={ref}
        className={`playercontainer_wrapper ${classes.errorDisplay}`}
        style={{ backgroundColor: "#333" }}
      >
        <div className="loader" style={{ color: "#fff" }}>
          <img src={ErrorIcon} className="erroricon" alt="error" />
          Error: {errorMessage}
        </div>
      </div>
    );
  }
);

Controls.propTypes = {
  onPlayerRefrence: PropTypes.ref,
  onSeek: PropTypes.function,
  onSeekMouseDown: PropTypes.function,
  onSeekMouseUp: PropTypes.function,
  onDuration: PropTypes.function,
  onRewind: PropTypes.function,
  onPlayPause: PropTypes.function,
  onFastForward: PropTypes.function,
  onVolumeSeekDown: PropTypes.function,
  onChangeDispayFormat: PropTypes.function,
  onPlaybackRateChange: PropTypes.function,
  onToggleFullScreen: PropTypes.function,
  onToggleDownload: PropTypes.function,
  onsubtitleTracksdisplay: PropTypes.function,
  onMute: PropTypes.function,
  playing: PropTypes.bool,
  showSpinner: PropTypes.bool,
  isAudio: PropTypes.bool,
  tickerLanguageControls: PropTypes.bool,
  played: PropTypes.number,
  elapsedTime: PropTypes.string,
  tittle: PropTypes.string,
  totalDuration: PropTypes.string,
  muted: PropTypes.bool,
  setConfig: PropTypes.bool,
  checked: PropTypes.bool,
  languagedata: PropTypes.object,
  tikcerdata: PropTypes.array,
  onFramerate: PropTypes.object,
  onsubtitleTracks: PropTypes.array,
  currentaudioTrack: PropTypes.number,
  livecount: PropTypes.string,
  levellsmain: PropTypes.number,
  playbackRate: PropTypes.number,
  subtitleTracksSelected: PropTypes.number,
  fullScreen: PropTypes.bool,
  onPip: PropTypes.function,
  pip: PropTypes.bool,
  isAdsShowing: PropTypes.bool,
  isMacOS: PropTypes.bool,
  subtitleDisplays: PropTypes.bool,
  onsubtitleTracksdisplay: PropTypes.function,
  handelChecked: PropTypes.function,
  handelToggleVisible: PropTypes.function,
  nextVod: PropTypes.object,
  handleClose: PropTypes.function,
  nextEpisodePlay: PropTypes.function,
  handelnextduration: PropTypes.function,
  isPlayer: PropTypes.string,
  catType: PropTypes.string,
  cuepPonits: PropTypes.array,

};
export default Controls;
